import { render, staticRenderFns } from "./DoctorPanel.vue?vue&type=template&id=58df0df0&scoped=true"
import script from "./DoctorPanel.vue?vue&type=script&lang=js"
export * from "./DoctorPanel.vue?vue&type=script&lang=js"
import style0 from "./DoctorPanel.vue?vue&type=style&index=0&id=58df0df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df0df0",
  null
  
)

export default component.exports